import { createFileRoute } from '@tanstack/react-router';
import { EditPage } from '@/pages/edit/EditPage';

export const Route = createFileRoute('/edit')({
  component: EditPage,
});
